import script from "./ProductFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProductFormDialog.vue?vue&type=style&index=0&id=2b99c734&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b99c734"]])

export default __exports__